export const dropDownCommands = {
  ADD_SINGLE_BID: 'ADD_SINGLE_BID',
  ADD_BULK_BID: 'ADD_BULK_BID',
};
